import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Move } from '@app/move/interfaces/move';
import { ArrayUtils, Mimetypes, SimpleChangesUtils } from '@smooved/core';
import { SvgIllustration, UiContext, UiIcon, UiIconSize } from '@smooved/ui';
import { WaterTransferAssetType } from '@ui/water/enums/water-transfer-asset-type.enum';
import { WaterMeter } from '@smooved-lib/lib/meters/types/water-meter';
import { MoveUtils } from '@app/move/state/move.utils';
import { WaterTransferDocumentService } from '@app/services/water-transfer-document/classes/water-transfer-document-service';
import { WaterFinalInvoiceService } from '@app/services/water-final-invoice/classes/water-final-invoice-service';
import { WaterNewContractService } from '@app/services/water-new-contract/classes/water-new-contract-service';

@Component({
    selector: 'app-water-meter-reading-details',
    templateUrl: 'water-meter-reading-details.component.html',
    styleUrls: ['./water-meter-reading-details.component.scss'],
})
export class WaterMeterReadingDetailsComponent implements OnChanges {
    ngOnChanges({ move }: SimpleChanges): void {
        if (SimpleChangesUtils.hasChanged(move)) {
            const { transferee, leaver } = MoveUtils.getMovers(move.currentValue);
            this.transferee = transferee;
            this.leaver = leaver;
        }
    }

    @Input() public move: Move;
    @Input() public waterTransferDocumentService: WaterTransferDocumentService;
    @Input() public waterFinalInvoiceService: WaterFinalInvoiceService;
    @Input() public waterNewContractService: WaterNewContractService;
    @Input() public waterMeter: WaterMeter;

    public transferee: Move;
    public leaver: Move;

    public readonly UiIconSize = UiIconSize;
    public readonly UiIcon = UiIcon;
    public readonly uiIcon = UiIcon;
    public readonly ArrayUtils = ArrayUtils;
    protected readonly WaterTransferAssetType = WaterTransferAssetType;
    protected readonly context = UiContext;
    protected readonly Mimetypes = Mimetypes;
    protected readonly svgIllustration = SvgIllustration;
    protected readonly SvgIllustration = SvgIllustration;
}
